import utils from "Sources/utils/utils";
//import NavUtils from "Sources/utils/navigation-utils";
const log = require("Sources/utils/logger")();
import LanguageManager from "Sources/services/language-manager";
import HtmlTemplate from "Views/partials/materials/mission-material.html";

import "Styles/components/mission-material.scss";

class MissionMaterial
{
  constructor(options)
  {
    this.$container = $(options.container);
    this.hasRendered = false;
    this.material = options.material;
    this.onMaterialAmountOpened = options.onMaterialAmountOpened;
    this.onMaterialSelected = options.onMaterialSelected;
    this.showCheckmark = options.showCheckmark;
    this.selected = false;
    this.infinite = false;
    this.showAmount = options.showAmount;
    this.maxAmount = options.maxAmount;
  }

  get material()
  {
    return this._material;
  }

  set material(material)
  {
    this._material = material;
    this.updateMissionMaterial();
  }

  static setUpMissionMaterial(options)
  {
    let instance = new MissionMaterial(options);
    instance.render();
    if(options.selected)
    {
      instance.setSelected();
      //instance.onMaterialSelected();
    }

    if(!utils.isNullOrEmpty(options.maxAmount) || !utils.isUndefined(options.maxAmount))
    {
      instance.material.amount = options.maxAmount;
    }
    else
    {
      instance.material.amount = 0;
    }

    if(!options.showCheckmark)
    {
      instance.$element.find("[data-bind-target='material-checkbox']").hide();
    }

    instance.updateMissionMaterial();

    instance.setUpEventListeners();
    return instance;
  }

  setUpEventListeners()
  {
    const AMOUNT_FIELD_ID = ".amount-input";
    const CHECKBOX_ID = ".material-checkbox";
    const AMOUNT_CLOSED_ID = ".material-amount-closed";
    const AMOUNT_CLOSED_TEXT_ID = ".material-amount-closed p";
    const INFINITE_BTN_ID = ".material-infinite-btn";

    let that = this;
    this.$element.find(AMOUNT_FIELD_ID).on("change", function(e)
    {
      that.infinite = false;
      that.material.amount = parseInt($(e.target).val());
      that.updateMissionMaterial();
    });

    this.$element.find(CHECKBOX_ID).on("change", function(e)
    {
      if(e.target.checked)
      {
        that.selected = true;
        that.material.amount = parseInt(that.$element.find(AMOUNT_FIELD_ID).val());
      }
      else
      {
        that.selected = false;
      }
      that.onMaterialSelected();
    });

    this.$element.find(INFINITE_BTN_ID).on("click", function(e)
    {
        that.infinite = true;
        that.material.amount = 0;
        that.$element.find(".material-amount-open").hide();
        that.updateMissionMaterial();
    });

    this.$element.find(AMOUNT_CLOSED_TEXT_ID).on("click", function(e)
    {
        let $amountOpen = that.$element.find(".material-amount-open");
        if($amountOpen.is(":visible"))
        {
          that.$element.find(".material-amount-open").hide();
          that.updateMissionMaterial();
        }
        else
        {
          that.onMaterialAmountOpened();
          that.$element.find(".material-amount-open").show();
        }
    });

    this.$element.find(AMOUNT_CLOSED_ID).on("click", function(e)
    {
      if(e.target === this)
      {
        let $amountOpen = that.$element.find(".material-amount-open");
        if($amountOpen.is(":visible"))
        {
          that.$element.find(".material-amount-open").hide();
          that.updateMissionMaterial();
        }
        else
        {
          if(that.selected)
          {
            that.onMaterialAmountOpened();
            that.$element.find(".material-amount-open").show();
          }

        }
      }
    });
  }

  setUnselected()
  {
    this.$element.find(".material-checkbox").prop("checked", false);
    this.selected = false;
  }

  setSelected()
  {
    this.$element.find(".material-checkbox").prop("checked", true);
    this.selected = true;
  }


  render()
  {
    this.hasRendered = false;
    this.$element = $(HtmlTemplate);
    this.$container.prepend(this.$element);
    LanguageManager.applyLocale(this.$element);

    this.updateMissionMaterial();
    this.hasRendered = true;
  }

  show()
  {
    if(utils.isNotNull(this.$element) && this.$element.length)
    {
      this.$element.show();
    }
  }

  hide()
  {
    if(utils.isNotNull(this.$element) && this.$element.length)
    {
      this.$element.hide();
    }
  }

  destroy()
  {
    if(utils.isNotNull(this.$element) && this.$element.length)
    {
      this.$element.remove();
    }
  }

  closeAndUpdate()
  {
    this.$element.find(".material-amount-open").hide();
    this.updateMissionMaterial();
  }

  updateMissionMaterial() {
    if (utils.isNotNull(this.$element) && this.$element.length) {
      let $materialName = this.$element.find("[data-bind-target='material-name']");
      $materialName.empty();

      if (utils.isNotNull(this.material) && utils.isNotNull(this.material.name) && utils.isNotNull(this.material.key)) {
        $materialName.text(this.material.name);
        $materialName.attr("for", "material-checkbox-" + this.material.key);
      }

      let $materialCount = this.$element.find("[data-bind-target='material-count']");
      $materialCount.empty();

      let $materialCheckbox = this.$element.find("[data-bind-target='material-checkbox']");
      $materialCheckbox.empty();

      if (utils.isNotNull(this.material) && utils.isNotNull(this.material.key)) {
        $materialCheckbox.attr("id", "material-checkbox-" + this.material.key);
      }

      let $materialClosedLabel = this.$element.find("[data-bind-target='material-amount-closed-label']");

      let $amountInput = this.$element.find(".amount-input");
      $amountInput.val(this.material.amount)
      $amountInput.attr("max", this.maxAmount);

      /*
      if(this.infinite)
      {
        $materialClosedLabel.text(LanguageManager.getValueForKey("mission_material.infinite_btn"));
      }
      else
      {
        let amountValue = this.$element.find("[data-bind-target='material-count-input']").val();
        if(utils.isNotNull(amountValue))
        {
          $materialClosedLabel.text(this.$element.find("[data-bind-target='material-count-input']").val());
        }
        else
        {

        }
      }

       */

      if(this.showAmount)
      {
        $(".amount-input").show();
      }
      else
      {
        $(".amount-input").hide();

      }

    }
  }

}

export default MissionMaterial;



// WEBPACK FOOTER //
// ./app/js/components/mission-material.js